













import Vue from 'vue';

export default Vue.extend({
  name: 'Rating',
  props: {
    count: Number,
    score: Number,
  },
  data() {
    return {
      stars: [''],
    };
  },
  created() {
    const rounded = Math.round(this.score * 10) / 10;

    this.stars = [];

    for (let i = 1; i < 6; i += 1) {
      if (rounded === i - 0.5) {
        this.stars.push('fa fa-star-half-o');
      } else if (rounded >= i) {
        this.stars.push('fa fa-star');
      } else {
        this.stars.push('fa fa-star-o');
      }
    }
  },
});
